import { render, staticRenderFns } from "./BooksList.vue?vue&type=template&id=024311aa&"
import script from "./BooksList.vue?vue&type=script&lang=js&"
export * from "./BooksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports